import { render, staticRenderFns } from "./detailRevenue.vue?vue&type=template&id=cd9d4516&scoped=true&"
import script from "./detailRevenue.vue?vue&type=script&lang=js&"
export * from "./detailRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9d4516",
  null
  
)

export default component.exports